import React, { Component } from 'react';
import { getOwnerContract }  from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';

class Contract extends Component {

    state = {
    };

    async componentDidMount() {
      // window.googleTranslateElementInit = () => {
      //   new window.google.translate.TranslateElement(
      //     { pageLanguage: 'en' },
      //     'google_translate_element'
      //   );
      // };
  
      // // Add the script tag to the HTML document
      // const script = document.createElement('script');
      // script.src = 'http://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      // script.defer = true;
      // document.body.appendChild(script);

    }

    addToMetamask = async () => {
        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const wasAdded = await window.ethereum.request({
              method: 'wallet_watchAsset',
              params: {
                type: 'ERC20', // Initially only supports ERC20, but eventually more!
                options: {
                  address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', // The address that the token is at.
                  // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
                  symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
                  decimals: 6, // The number of decimals in the token
                    //   image: tokenImage, // A string url of the token logo
                },
              },
            });
          
            if (wasAdded) {
              console.log('Thanks for your interest!');
            } else {
              console.log('Your loss!');
            }
          } catch (error) {
            console.log(error);
          }
    }

    addBUSOToMetamask = async () => {
      try {
          // wasAdded is a boolean. Like any RPC method, an error may be thrown.
          const wasAdded = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20', // Initially only supports ERC20, but eventually more!
              options: {
                address: '0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2', // The address that the token is at.
                // address: '0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f', // The address that the token is at.
                symbol: 'BUSO', // A ticker symbol or shorthand, up to 5 chars.
                decimals: 6, // The number of decimals in the token
                  //   image: tokenImage, // A string url of the token logo
              },
            },
          });
        
          if (wasAdded) {
            console.log('Thanks for your interest!');
          } else {
            console.log('Your loss!');
          }
        } catch (error) {
          console.log(error);
        }
    }

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
                    <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                        {/* Top Panel, Matrix levels and all activies inside below div */}
                        <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#f7ff07ff" }}>INFINITY XGOLD:</span> <a href='https://polygonscan.com/address/0x12eb4DAAA39C2A171283C3BF823Dcf95eaAd6220' target="_blank">0x12e...d6220</a>
                            </div>
                            <div className="text-lg sm:text-md">
                              <span style={{ color: "#f7ff07ff" }}>INFINITY AUTORUN:</span> <a href='https://polygonscan.com/address/0xd61597041C0E053ed237174Da4a2688a6c11F62e' target="_blank">0xd61...1F62e</a>
                            </div>
                               <div className="text-lg sm:text-md">
                              <span style={{ color: "#f7ff07ff" }}>INFINITY AUTORUN PLUS:</span> <a href='https://polygonscan.com/address/0x008fAA6904847bBE51D5FC28b87423E79ed15E79' target="_blank">0x008...15E79</a>
                            </div>
                             <div className="text-lg sm:text-md">
                              <span style={{ color: "#f7ff07ff" }}>INFINITY AUTORUN 3:</span> <a href='https://polygonscan.com/address/0x4a0290eB53CeD1eF39F13E6cCAf8dFf0aDeE1154' target="_blank">0x4a0...E1154</a>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}
 
export default withWrapper(Contract);